var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-partners" },
    [
      _vm._l(_vm.filteredPartners, function (partner) {
        return _c(
          "div",
          { key: partner.id, staticClass: "page-partners__container" },
          [
            _c("partners-link", {
              attrs: {
                partner: partner,
                currentPartner: _vm.currentPartner,
                value: partner.id,
              },
              on: { "on-change-partner": _vm.onChangeActivePartner },
            }),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShowMore,
              expression: "isShowMore",
            },
          ],
        },
        _vm._l(_vm.filteredPartnersShowMore, function (partner) {
          return _c(
            "div",
            { key: partner.id, staticClass: "page-partners__container" },
            [
              _c("partners-link", {
                attrs: {
                  partner: partner,
                  currentPartner: _vm.currentPartner,
                  value: partner.id,
                },
                on: { "on-change-partner": _vm.onChangeActivePartner },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.partners && _vm.partners.length > 8
        ? _c("div", { staticClass: "page-partners__show-more" }, [
            _c(
              "span",
              {
                staticClass: "page-partners__show-more-items",
                on: { click: _vm.showMore },
              },
              [
                _vm._v("\n        Показать больше\n           "),
                _c("IconChevronDown", {
                  class: _vm.isShowMore ? "show-open" : "",
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }